import TsdiCounty from 'src/models/projectSettings/TsdiCounty';

export default class TsdiSubcode {
    projectId?: number;
    id?: number;
    section?: number;
    township?: string;
    range?: string;
    number?: number;
    type?: string;
    survey?: string;
    surveyType?: string;
    abstract?: number;
    block?: string;
    fraction?: string;
    sectionTexas?: string;
    distName?: string;
    name?: string;
    townshipName?: string;
    meridian?: string;
    tsdiNoAssigned?: number;
    afeNumber?: string;
    clmNumber?: number;
    clientPropertyId?: number;
    clientSectionName?: string;
    clientAccountCode?: string;
    clientLandmanName?: string;
    crewChief?: number;
    budgetAmount?: number;
    afeAmount?: number;
    counties?: Array<TsdiCounty>;
}


// WEBPACK FOOTER //
// ./src/models/AP/Subcode.ts